import React from "react";

interface DeleteIconProps {
  className?: string;
  onClick?: () => void;
}

const DeleteButtonWithBg: React.FC<DeleteIconProps> = ({
  className,
  onClick,
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      onClick={onClick}
    >
      <rect width="24" height="24" rx="4" fill="#EA4335" />
      <path
        d="M18.1875 6.9375H5.8125"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.1875 4.6875H14.8125"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M17.0625 6.9375V17.625C17.0625 17.7742 17.0032 17.9173 16.8977 18.0227C16.7923 18.1282 16.6492 18.1875 16.5 18.1875H7.5C7.35082 18.1875 7.20774 18.1282 7.10225 18.0227C6.99676 17.9173 6.9375 17.7742 6.9375 17.625V6.9375"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default DeleteButtonWithBg;
